export default "__VITE_ASSET___mEgVowY__";